import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "../api/client";
import { useAuth } from "../context/AuthContext";
import { ru } from "../locales/ru";

export default function Register() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const inviteCode = params.get("invite") || "";
  const [form, setForm] = useState({ name: "", phone: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const payload = inviteCode ? { ...form, invite_code: inviteCode } : form;
      const { data } = await api.post("/auth/register", payload);
      setUser(data);
      navigate("/orders");
    } catch (err) {
      setError(formatApiError(err, ru.errors.generic));
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full h-14 px-4 bg-gray-100 rounded-xl text-base outline-none focus:ring-2 focus:ring-black";

  return (
    <div className="min-h-screen flex flex-col justify-center px-6 pb-24">
      <h1 className="text-4xl font-extrabold tracking-tight mb-2" data-testid="register-title">
        {ru.auth.registerTitle}
      </h1>
      <p className="text-gray-500 mb-10" data-testid="register-subtitle">
        {inviteCode ? ru.auth.inviteOnly : ru.auth.openRegistration}
      </p>
      <form onSubmit={submit} className="space-y-4">
        <input data-testid="register-name-input" value={form.name} onChange={set("name")} placeholder={ru.auth.namePlaceholder} className={inputCls} required />
        <input data-testid="register-phone-input" type="tel" value={form.phone} onChange={set("phone")} placeholder={ru.auth.phonePlaceholder} className={inputCls} required />
        <input data-testid="register-password-input" type="password" value={form.password} onChange={set("password")} placeholder={ru.auth.passwordPlaceholder} className={inputCls} required minLength={6} />
        {inviteCode && (
          <div className="bg-gray-100 rounded-xl px-4 py-3" data-testid="register-invite-input">
            <p className="text-xs font-semibold text-gray-500">{ru.auth.inviteCode}</p>
            <p className="font-mono text-sm font-semibold truncate">{inviteCode}</p>
          </div>
        )}
        {error && (
          <p data-testid="register-error" className="text-sm text-[#FF3B30] px-1">{error}</p>
        )}
        <button
          data-testid="register-submit-button"
          type="submit"
          disabled={loading}
          className="w-full h-14 bg-black text-white rounded-2xl font-medium text-base active:scale-[0.98] transition-transform duration-200 disabled:opacity-50"
        >
          {ru.auth.registerBtn}
        </button>
      </form>
      <p className="text-center text-sm text-gray-500 mt-8">
        {ru.auth.haveAccount}{" "}
        <Link to="/login" data-testid="register-to-login-link" className="text-black font-semibold underline">
          {ru.auth.toLogin}
        </Link>
      </p>
    </div>
  );
}
